export const unitEconomyCase = {
    id: 'unit-economy',
    title: 'Unit Economics Optimization',
    subtitle: 'SaaS Cost Structure Transformation',
    category: 'Financial Modeling',
    description: 'Advanced financial modeling and cost structure optimization helped a growing SaaS company achieve sustainable unit economics.',
    status: 'success',
    tags: ['SaaS', 'Financial Modeling', 'Cost Optimization'],
    coverImage: '/cospin-logo.png',
    heroImage: '/cospin-logo.png',
    challenge: `A rapidly growing SaaS company was struggling with unsustainable unit economics, impacting their path to profitability. Their customer acquisition costs (CAC) were increasing while lifetime value (LTV) remained stagnant, creating an unsustainable business model.`,
    solution: `Cospin implemented a comprehensive unit economics optimization program:
  • Detailed analysis of cost drivers and revenue streams
  • Implementation of automated cost tracking systems
  • Development of predictive models for customer behavior
  • Restructuring of pricing tiers and feature bundling
  • Optimization of customer acquisition channels`,
    results: [
        'Reduced Customer Acquisition Cost (CAC) by 45%',
        'Increased Customer Lifetime Value (LTV) by 60%',
        'Improved LTV/CAC ratio from 1.5 to 3.8',
        'Achieved positive unit economics within 6 months',
        'Established automated monitoring systems for key metrics'
    ],
    metrics: {
        timeframe: '6 months',
        roi: '280%',
        costReduction: '45%',
        revenueIncrease: '60%'
    },
    testimonial: {
        quote: "Cospin's approach to unit economics wasn't just about numbers—it was about building a sustainable business model that could scale.",
        author: "CFO, Enterprise SaaS Company"
    },
    filePath: '/case-studies/Cospin_CaseStudy_UnitEconomy.pdf'
};
